const Apps = [
    {
        context: 'dashboard',
        name: 'Dashboard',
        icon: '/assets/dashboard.svg',
        alt: 'dashboard-item',
    },
    {
        context: 'chart',
        name: 'Charts',
        icon: '/assets/charts.png',
        alt: 'charts-item',
    },
    {
        context: 'currency',
        name: 'Stories',
        icon: '/assets/stories.png',
        alt: 'stories-item',
    },
    // We will include Maps and Surveys after design and wizards are done
    {
        context: 'maps',
        name: 'Maps',
        icon: '/assets/maps.svg',
        alt: 'maps-item',
        exclude: true, // TODO: Temporary
    },
    {
        context: 'surveys',
        name: 'Surveys',
        icon: '/assets/surveys.svg',
        alt: 'surveys-item',
        exclude: true, // TODO: Temporary
    },
    {
        context: 'geobuffer',
        name: 'Geobuffer',
        icon: '/assets/geobuffer.svg',
        alt: 'geobuffer-item',
        exclude: true, // TODO: Temporary
    },
    {
        context: 'layout',
        name: 'Templates',
        icon: '/assets/stories.png',
        alt: 'template-item',
        exclude: true,
    },
];

export default Apps;



// WEBPACK FOOTER //
// ./src/enums/AppsInfo.js